import { DataExtractionRowViewModel } from "../ViewModels/DataExtractionTableRow";
import { TravlDataViewModel } from "../ViewModels/TravlDataViewModel";

export default function toExtractionRow(vm: TravlDataViewModel): DataExtractionRowViewModel {
    return {
        surveyCode: vm.SurveyCode,
        landUse: vm.LandUseDesc,
        name: vm.Name,
        borough: vm.BoroughName,
        surveyDate: vm.SurveyDate,
        PTAL: vm.PTAL,
        area: vm.LocationCodeShortDescription, 
        totalParking: vm.ParkTotal,
        surveyHrs1: vm.SurveyHrs1,
        GFA: vm.GFA,
        RFA: vm.RFA,
        employ: vm.Employ,
        siteArea: vm.SiteArea,
        rooms: vm.Rooms,
        seats: vm.Seats,
        beds: vm.Beds,
        doctors: vm.Doctors,
        resUnits: vm.ResUnits,
        conRooms: vm.ConRooms,
        studentsA: vm.StudentsA,
        studentsB: vm.StudentsB,
        screens: vm.Screens
    }
}
